import SumIcon from '../../assets/icons/Sum.svg';
import NotesCheckIcon from '../../assets/icons/NotesCheck.svg';
import NotesCancelIcon from '../../assets/icons/NotesCancel.svg';
interface Props{
  metrics: {
    total?:number;
    approved?:number;
    rejected?:number;
  },
  isLoading?:boolean;  
}

const ApplicationOverview:React.FC<Props> = ({metrics, isLoading}) => {
    return (
        <div className="bg-white shadow rounded-[8px] py-[20px] px-4 mt-[6px] mb-[20px] flex items-center md:px-[60px]">
            {isLoading && <div>Loading</div>}
            {!isLoading &&
                <div className="flex-1">
                {" "}
                <h2 className="text-[24px] font-ubuntu font-[600]">
                    Applications
                </h2>{" "}
                <hr className="border-[1px] border-gray-300 my-4" />{" "}
                <div className="grid gap-4 mt-[20px] md:grid-cols-3">
                    {" "}
                    <div className="bg-white shadow-lg rounded-[8px] py-[20px] px-[30px] flex flex-row justify-between items-center transition-all duration-300 hover:scale-105">
                    {" "}
                    <div className="flex flex-col text-left">
                        <h3 className="text-[14px] font-ubuntu font-[500]">
                        Total
                        </h3>{" "}
                        <p className="text-[24px] text-[#0073C0] font-ubuntu font-[500]">
                        {metrics.total}
                        </p>{" "}
                    </div>
                    <div>
                        <img src={SumIcon} />
                    </div>
                    </div>{" "}
                    <div className="bg-white shadow-lg rounded-[8px] py-[20px] px-[30px] flex flex-row justify-between transition-all duration-300 hover:scale-105">
                    {" "}
                    <div className="flex flex-col text-left">
                        <h3 className="text-[14px] font-ubuntu font-[500]">
                        Approved
                        </h3>{" "}
                        <p className="text-[24px] text-[#00BE13] font-ubuntu font-[500]">
                        {metrics.approved}
                        </p>{" "}
                    </div>
                    <div>
                        <img src={NotesCheckIcon} />
                    </div>
                    </div>{" "}
                    <div className="bg-white shadow-lg rounded-[8px] py-[20px] px-[30px] flex flex-row justify-between transition-all duration-300 hover:scale-105">
                    {" "}
                    <div className="flex flex-col text-left">
                        <h3 className="text-[14px] font-ubuntu font-[500]">
                        Rejected
                        </h3>{" "}
                        <p className="text-[24px] text-[#C10000] font-ubuntu font-[500]">
                        {metrics.rejected}
                        </p>{" "}
                    </div>
                    <div>
                        <img src={NotesCancelIcon} />
                    </div>
                    </div>{" "}
                </div>{" "}
                </div>
            }
        </div>
    )
}

export default ApplicationOverview;